/**
 * Lean Customs "Laadplaats" (transport_extra_eu) amount from booking fields.
 *
 * FCL seafreight: pickup + Terminal handling plaats van oorsprong.
 * Origin THC from pricing templates already includes export clearance (€45),
 * so we must not add export clearance again (40ft €595 → €550 net THC + €45 EC).
 *
 * LCL / air / no THC: pickup + export clearance (€45 when flagged).
 */

export const LEANCUSTOMS_EXPORT_CLEARANCE_COST = 45;

/** Net origin THC after stripping the embedded export clearance. */
export function originThcNetOfExportClearance(originThcGross: number): number {
  return Math.max(0, originThcGross - LEANCUSTOMS_EXPORT_CLEARANCE_COST);
}

export type LeanCustomsFreightCostsBreakdown = {
  amount: number;
  pickupFee: number;
  /** Gross origin THC from template (includes export clearance when present). */
  originThc: number;
  /** Export clearance added as a separate line (0 when included in origin THC). */
  exportClearanceApplied: number;
  /** True when origin THC was used and therefore EC was not added again. */
  exportClearanceIncludedInThc: boolean;
};

export function calculateLeanCustomsFreightCostsToEu(args: {
  pickupFee: number | null | undefined;
  exportClearance: boolean | null | undefined;
  isFclSeafreight: boolean;
  /** Template value for "Terminal handling plaats van oorsprong" (gross, incl. EC). */
  originTerminalHandling: number | null | undefined;
}): LeanCustomsFreightCostsBreakdown {
  const pickupFee = Math.max(0, Number(args.pickupFee) || 0);
  const originThc =
    args.originTerminalHandling != null && args.originTerminalHandling > 0
      ? Math.round(Number(args.originTerminalHandling) * 100) / 100
      : 0;

  if (args.isFclSeafreight && originThc > 0) {
    return {
      amount: Math.round((pickupFee + originThc) * 100) / 100,
      pickupFee,
      originThc,
      exportClearanceApplied: 0,
      exportClearanceIncludedInThc: true,
    };
  }

  const exportClearanceApplied =
    args.exportClearance === true ? LEANCUSTOMS_EXPORT_CLEARANCE_COST : 0;

  return {
    amount: Math.round((pickupFee + exportClearanceApplied) * 100) / 100,
    pickupFee,
    originThc: 0,
    exportClearanceApplied,
    exportClearanceIncludedInThc: false,
  };
}
